import { render, staticRenderFns } from "./ProductIndex.vue?vue&type=template&id=3debd16e"
import script from "./ProductIndex.vue?vue&type=script&lang=js"
export * from "./ProductIndex.vue?vue&type=script&lang=js"
import style0 from "./ProductIndex.vue?vue&type=style&index=0&id=3debd16e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports